import styled from 'styled-components';

const ContentText = styled.div`
  font-size: 14px;
  color: rgba(23, 60, 81, 0.5);
`;

export default ContentText;
